// Ported from wb-server/zoe/src/services/auth.ts
import { get, writable } from 'svelte/store';

import { appConfig } from './app-config';
import { ROOT_SERVER_URL } from '../config';

function getAccessTokenFromCookie(cookieName) {
  for (const cookie of document.cookie.split(';')) {
    const [name, value] = cookie.split('=').map((v) => v.trim());
    if (name === cookieName) {
      return value;
    }
  }
  return undefined;
}

function decodeAccessToken(token) {
  if (!token) {
    return undefined;
  }
  try {
    const segment = token.split('.')[1];
    return JSON.parse(atob(segment));
  } catch (_) {
    return undefined;
  }
}

function isTokenExpired(decoded) {
  if (!decoded || !decoded.exp) {
    return true;
  }
  return Date.now() >= decoded.exp * 1000;
}

const store = writable({ loading: true }, function start(set) {
  const unsubscribe = appConfig.subscribe((config) => {
    if (config.loading || config.error) {
      return;
    }

    try {
      const { mstMaceAuthCookie } = config.data;
      const accessToken = getAccessTokenFromCookie(mstMaceAuthCookie);
      const decoded = decodeAccessToken(accessToken);

      if (!decoded || isTokenExpired(decoded)) {
        set({ loading: false });
        return;
      }

      const session = { accessToken, decoded };
      const userProfile = {
        sub: decoded.sub,
        email: decoded.email,
        name: decoded.name,
      };

      set({ session, userProfile, loading: false });
    } catch (error) {
      console.error('[userSession] An error occurred while checking session!', error);
      set({ loading: false, error });
    }
  });

  return () => {
    unsubscribe();
  };
});

const { subscribe, set, update } = store;

async function refresh() {
  update((values) => ({ ...values, loading: true }));

  try {
    const config = get(appConfig);
    if (!config.data) {
      set({ loading: false });
      return;
    }

    const { mstMaceAuthCookie } = config.data;
    const accessToken = getAccessTokenFromCookie(mstMaceAuthCookie);
    const decoded = decodeAccessToken(accessToken);

    if (!decoded || isTokenExpired(decoded)) {
      set({ loading: false });
      return;
    }

    const session = { accessToken, decoded };
    const userProfile = {
      sub: decoded.sub,
      email: decoded.email,
      name: decoded.name,
    };

    set({ session, userProfile, loading: false });
    return session;
  } catch (error) {
    console.error('[userSession] An error occurred while refreshing session!', error);
    set({ loading: false, error });
  }
}

function signOut() {
  window.location.href = `${ROOT_SERVER_URL}/api/authorization/logout`;
}

export const userSession = {
  subscribe,
  refresh,
  signOut,
};
